/**
 * A link into the app (inventory, 26A): `?widget=todos&tab=lists&list=7`
 * opens that widget with that tab and those params — what a push
 * notification's link does. `?connected=google` is where a connection's flow
 * returns (`/oauth/{provider}/callback`). Both are read once, at open, and
 * taken out of the address bar so a reload does not do it again.
 */
import { nowAt, type Open, type Params } from "./layout";

export interface DeepLink {
  open: Open | null;
  connected: string | null;
  /** The address with the link's parts taken out. */
  cleaned: string;
}

export function readDeepLink(url: URL, known: (key: string) => boolean): DeepLink {
  const query = new URLSearchParams(url.search);
  const asked = query.get("widget");
  const name = asked === null ? null : nowAt(asked);
  const tab = query.get("tab");
  const connected = query.get("connected");
  let open: Open | null = null;
  if (name !== null && known(name)) {
    const params: Params = {};
    for (const [key, value] of query) {
      if (key !== "widget" && key !== "tab" && key !== "connected") params[key] = value;
    }
    open = { name, tab, params: Object.keys(params).length ? params : null };
  }
  const cleaned =
    name !== null || connected !== null ? url.pathname : `${url.pathname}${url.search}`;
  return { open, connected, cleaned: `${cleaned}${url.hash}` };
}
